import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as req from 'api/actions';
import _ from 'lodash';
import Loader from 'modules/common/components/Loader';
import * as c from '../constants';

export const mapStateToProps = ({ api }) => ({
  auth: _.get(api, c.AUTH) || {},
});

const getProfile = () => {
  try {
    return JSON.parse(sessionStorage.getItem('profile')) || {};
  } catch (err) {
    return {};
  }
};

export const hocComponent = WrappedComponent => {
  function withAuth(props) {
    useEffect(() => {
      const token = sessionStorage.getItem('token');
      props.setItem(c.AUTH, {
        token,
        isAuthenticated: !!token,
      });
      props.setItem(c.USER_PROFILE, getProfile());
    }, []);
    const { auth } = props;
    if (_.isEmpty(auth)) return <Loader />;
    return <WrappedComponent {..._.omit(props, ['setItem'])} />;
  }
  withAuth.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    setItem: PropTypes.func.isRequired,
  };
  return withAuth;
};

export default WrapperComponent =>
  connect(mapStateToProps, { ..._.pick(req, ['setItem']) })(
    hocComponent(WrapperComponent)
  );
